import {Component, OnDestroy, OnInit} from '@angular/core';
import {WebOnboardingService} from '../../_services/web-onboarding.service';
import {EnvironmentService} from '../../_services/enviroment.service';

@Component({
  selector: 'app-registrar-cliente',
  templateUrl: './registrar-cliente.component.html',
  styleUrls: ['./registrar-cliente.component.css'],
})
export class RegistrarClienteComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  errorMessage: string = '';
  qrUrl: string = '';
  expired: boolean = false;

  private refreshInterval: any = null;
  private expiryTimeout: any = null;
  private readonly REFRESH_SECONDS = 8;
  private readonly CYCLE_DURATION_SECONDS = this.REFRESH_SECONDS * 4;

  isProduction: boolean;

  constructor(private onboardingService: WebOnboardingService, private envService: EnvironmentService) {
    this.isProduction = this.envService.environmentProduction();
  }

  ngOnInit(): void {
    this.startCycle();
  }

  ngOnDestroy(): void {
    this.stopAll();
  }

  startCycle(): void {
    this.expired = false;
    this.loading = true;
    this.errorMessage = '';
    this.generateQr();
    this.startAutoRefresh();

    this.expiryTimeout = setTimeout(() => {
      this.stopAll();
      this.qrUrl = '';
      this.expired = true;
    }, this.CYCLE_DURATION_SECONDS * 1000);
  }

  private generateQr(): void {
    this.onboardingService.generateLink().subscribe({
      next: (response) => {
        this.qrUrl = response.url;
        this.loading = false;
      },
      error: (err) => {
        this.errorMessage = err.error?.message || 'Error al generar el enlace.';
        this.loading = false;
        this.stopAll();
        this.expired = true;
      },
    });
  }

  private startAutoRefresh(): void {
    this.stopAutoRefresh();
    this.refreshInterval = setInterval(() => {
      this.generateQr();
    }, this.REFRESH_SECONDS * 1000);
  }

  private stopAutoRefresh(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  private stopAll(): void {
    this.stopAutoRefresh();
    if (this.expiryTimeout) {
      clearTimeout(this.expiryTimeout);
      this.expiryTimeout = null;
    }
  }
}
